import { styled } from '@mui/material';
import { theme } from '@unicorn/bms-theme';

export const Container = styled('div')`
  position: absolute;
  left: 230px;
  top: -54px;
  z-index: 100;
  border: 1px solid ${theme.palette.grey[300]};
  border-radius: 4px;
  padding: 7px 12px;
  z-index: 1000;
`;

export const Label = styled('div')`
  display: flex;
  gap: 6px;
  align-items: center;
`;
